var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 15.5 4.5 20 10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 0 10 0C4.5 0 0 4.5 0 10ZM1.25 10C1.25 5.125 5.125 1.25 10 1.25C14.875 1.25 18.75 5.25 18.75 10C18.75 14.75 14.75 18.75 10 18.75C5.25 18.75 1.25 14.875 1.25 10Z",
    fill: "#E64B38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99988 12.5001C9.62488 12.5001 9.37488 12.2501 9.37488 11.8751V5.12511C9.37488 4.75011 9.62488 4.50011 9.99988 4.50011C10.3749 4.50011 10.6249 4.75011 10.6249 5.12511V11.8751C10.6249 12.2501 10.3749 12.5001 9.99988 12.5001Z",
    fill: "#E64B38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99976 15.6251C9.74976 15.6251 9.49976 15.5001 9.37476 15.3751C9.24976 15.2501 9.12476 15.0001 9.12476 14.7501C9.12476 14.6251 9.12476 14.5001 9.12476 14.3751C9.12476 14.2501 9.24976 14.1251 9.24976 14.1251C9.49976 13.8751 9.87476 13.7501 10.1248 14.0001C10.2498 14.0001 10.3748 14.1251 10.3748 14.1251C10.4998 14.2501 10.4998 14.2501 10.4998 14.3751C10.4998 14.5001 10.4998 14.6251 10.4998 14.7501C10.4998 14.8751 10.4998 15.0001 10.4998 15.1251C10.4998 15.2501 10.3748 15.2501 10.3748 15.3751C10.4998 15.6251 10.2498 15.6251 9.99976 15.6251Z",
    fill: "#E64B38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError2);
export default __webpack_public_path__ + "static/media/error-2.eb8541235a8b3bbf8d6a5ec8a56b8e39.svg";
export { ForwardRef as ReactComponent };